module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-976-min.430a8233.jpg";